// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".loni-cell[data-v-52b62865]{width:100%}.loni-cell.radius[data-v-52b62865] .loni-cell-item.spacing+*,.loni-cell.radius[data-v-52b62865] .loni-cell-item:first-child{border-top-left-radius:6px;border-top-right-radius:6px}.loni-cell.radius[data-v-52b62865] .loni-cell-item.spacing,.loni-cell.radius[data-v-52b62865] .loni-cell-item:last-child{border-bottom-left-radius:6px;border-bottom-right-radius:6px}", ""]);
// Exports
module.exports = exports;
